module.exports = __webpack_public_path__ + "static/img/epr55.4887066.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/epr55.jpeg
// module id = lJ04
// module chunks = 73